module.exports = __webpack_public_path__ + "fonts/GaramontAmsterdamBQ-Medium.87c44638.eot";